// extracted by mini-css-extract-plugin
export default {"singleAdElementContainer":"SingleAdElement_singleAdElementContainer__UA9ud"};